/**
 * External destinations opened from the presentation.
 * Both open in a new browser tab so the deck stays live behind them.
 */

export const VEXU_PORTAL_URL = 'https://console.vexu.ai'

/** Talab live experience — opened from the "Experience Talab Live" CTA. */
export const TALAB_URL = 'https://app.talab.app'

export function openExternal(url: string) {
  if (!url) return
  window.open(url, '_blank', 'noopener,noreferrer')
}
